var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMessage = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11c0-.553.448-1 1-1s1 .447 1 1c0 .551-.448 1-1 1s-1-.449-1-1zm5-1c-.552 0-1 .447-1 1 0 .551.448 1 1 1s1-.449 1-1c0-.553-.448-1-1-1zm4 0c-.552 0-1 .447-1 1 0 .551.448 1 1 1s1-.449 1-1c0-.553-.448-1-1-1zm3.899 2.294c-.507 3.254-3.13 5.953-6.38 6.562-1.568.296-3.166.127-4.616-.487-.411-.174-.836-.262-1.253-.262-.19 0-.378.018-.563.055l-2.812.562.563-2.817c.118-.585.046-1.21-.207-1.81-.614-1.45-.782-3.047-.487-4.617.609-3.249 3.307-5.872 6.562-6.379 2.59-.403 5.123.413 6.95 2.241 1.83 1.83 2.647 4.363 2.243 6.952zm-.827-8.366c-2.285-2.284-5.445-3.303-8.674-2.804-4.077.636-7.457 3.92-8.22 7.987-.368 1.958-.156 3.952.61 5.765.098.231.128.446.09.64l-.858 4.287c-.066.328.037.667.274.903.189.19.444.293.707.293.065 0 .13-.006.196-.019l4.283-.857c.246-.047.484.022.643.088 1.815.767 3.809.978 5.765.611 4.068-.763 7.352-4.143 7.988-8.22.502-3.227-.52-6.389-2.804-8.674z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMessage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/message.c50c68c0.svg";
export { ForwardRef as ReactComponent };